/* Fase 15: color de Safari al cambiar tema, y entradas en páginas secundarias. */
(function () {
  var root = document.documentElement;
  function paint(mode) {
    var c = mode === 'dark' ? '#061A3A' : '#F3F9FF';
    var metas = document.querySelectorAll('meta[name=theme-color]');
    for (var i = 0; i < metas.length; i++) { metas[i].removeAttribute('media'); metas[i].setAttribute('content', c); }
  }
  function wrap() {
    var NM = window.NM;
    if (!NM || !NM.applyTheme || NM.applyTheme._p15) return;
    var prev = NM.applyTheme;
    var next = function (t) { prev(t); paint(t); };
    next._p15 = true;
    NM.applyTheme = next;
  }
  wrap();
  document.addEventListener('DOMContentLoaded', wrap);
  var nodes = Array.prototype.slice.call(document.querySelectorAll('.sec-enter'));
  if (!nodes.length || root.classList.contains('rm')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('js-anim-ready');
  if (!('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  nodes.forEach(function (n) { io.observe(n); });
  setTimeout(function () { nodes.forEach(function (n) { n.classList.add('is-in'); }); }, 1800);
})();
